<template>
    <div>
        <vs-dialog width="550px" not-center v-model="active" @close="borrarInfo">
            <div class="con-content">
                <div>
                    <label class="mt-2">Selecciona un motivo para cancelar factura</label>
                  <vs-select class="pl-0" placeholder="Seleccione un motivo" v-model="motivo">
                    <template #message-danger v-if="errorFields.includes('motivo')">
                      Requerido
                    </template>
                    <!-- <vs-option label="01 - Comprobantes emitidos con errores con relación" value="01">
                      01 - Comprobantes emitidos con errores con relación
                    </vs-option> -->
                    <vs-option label="02 - Comprobantes emitidos con errores sin relación" value="02">
                      02 - Comprobantes emitidos con errores sin relación
                    </vs-option>
                    <vs-option label="03 - No se llevó a cabo la operación" value="03">
                      03 - No se llevó a cabo la operación
                    </vs-option>
                    <vs-option label="04 - Operación nominativa relacionada en una factura global" value="04">
                      04 - Operación nominativa relacionada en una factura global
                    </vs-option>
                  </vs-select>
                </div>
                <h5>¿Esta seguro de cancelar masivamente las facturas seleccionadas?</h5>
            </div>

            <template #footer>
            <div class="con-footer" style="display: flex; justify-content: center;">
                <vs-button danger @click="getCerrar()">
                Cancelar
                </vs-button>
                <vs-button success @click="postCancelarFacturaMasiva()">
                Aceptar
                </vs-button>
            </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import reportes from '../../../../../api/requests/reportes.js'
export default {
    props:[
      'value',
      'selected'
    ],
    data(){
        return{
            active: false,
            concepto: '',
            foliosustitucion: '',
            motivo: '',
            errorFields: []
        }
    },
    methods:{
        sanityForm () {
            this.errorFields = []
            if (!this.motivo) {
                this.errorFields.push('motivo')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return false
            }
        },
        async postCancelarFacturaMasiva(){
            const vm = this
            if(this.sanityForm() == true){
            const loading = this.$vs.loading()
            try { 
                const uuid = this.selected.map(el => el.factura.uuid)
                const payload = { uuids: uuid, motivo: this.motivo}
                const response = await reportes.postCancelarFacturaMasiva(payload)
                console.log(response)
                if(response.success[0]){
                    const comentario  = response.success
                    comentario.forEach( c => {
                        vm.$vs.notification({
                            progress: 'auto',                           
                            color: 'success',
                            position: null,
                            title: 'Operación éxitosa',
                            text: c.message
                        })
                    })
                }
                if(response.error[0]){
                    const comentarioError  = response.error
                    comentarioError.forEach( c => {
                        vm.$vs.notification({
                            progress: 'auto',                           
                            color: 'danger',
                            position: null,
                            title: 'Algo salio mal',
                            text: c.message
                        })
                    })
                }
                    this.$emit('refreshTable',true)
                    this.borrarInfo()
                    loading.close()
            } catch (error) {
                console.log(error)
                loading.close()
                this.borrarInfo()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: error.response.data.message
                })
            }
            }
        },
        borrarInfo(){
            this.motivo = ''
            this.foliosustitucion = ''
            this.active = false
        }
    },
    watch: {
        value (val) {
            this.active = val
        },    
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>